export default __webpack_public_path__ + "static/media/air_purifier3.6ef6da6d.jpg";